/**
 * A collection of String-based constants.
 * @hidden
 * @ignore Exclude from docs
 */

/**
 * @ignore Exclude from docs
 */
export let PX: string = "px";

/**
 * @ignore Exclude from docs
 */
export let STRING: string = "string";

/**
 * @ignore Exclude from docs
 */
export let NUMBER: string = "number";

/**
 * @ignore Exclude from docs
 */
export let DATE: string = "date";

/**
 * @ignore Exclude from docs
 */
export let DURATION: string = "duration";

/**
 * @ignore Exclude from docs
 */
export let PLACEHOLDER: string = "__§§§__";

/**
 * @ignore Exclude from docs
 */
export let PLACEHOLDER2: string = "__§§§§__";



// WEBPACK FOOTER //
// ../../../../../src/.internal/core/utils/Strings.ts